import { StandardLayout } from 'shared/layout/StandardLayout'
import { NextPage } from 'next'
import { About } from 'experiences/about'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'

const Index: NextPage<PageProps> = ({ metaTags }) => (
	<StandardLayout metaTags={metaTags}>
		<About />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default Index
